const recalculateStatus = {
  neverRecalculate: 0,
  recalculating: 1,
  recalculated: 2
}

module.exports = {
  recalculateStatus
}
